imageManager = require 'imageManager'
soundManager = require 'soundManager'
eventManager = require 'eventManager'
gameModel = require 'gameModel'

class BaseButton extends PIXI.Container

  tag: 'button'
  text: 'Click'

  isEnabled: true
  interactive: true
  buttonMode: true

  action: null
  remainActive: false

  w: 288
  h: 42


  style:
    fontSize: 16
    fontWeight: 400
    fill: "#FFFFFF"
    align: "center"
    lineHeight: 22

  #----------------------------------------------

  constructor: (options) ->

    @options = options

    super()


    @w = options.width if options.width?
    @h = options.height if options.height?

    @text = options.text
    @style.fontFamily = gameModel.getFont()

    @action = options.action if options.action?
    @remainActive = options.remainActive if options.remainActive?

    @setupImage(options)

    if not options?.type? or options.type isnt 'menu'
      @addTextLabel()

    if options.toggleState?
      if options.toggleState
        @setOn()
      else
        @setOff()

  #----------------------------------------------

  setupImage: (options) ->

    @enable()
    @removeChildren()

    if options?.type? and options.type isnt 'menu'
      options.buttonImage = new PIXI.Texture.fromImage options.buttonImage
      options.buttonHoverImage = new PIXI.Texture.fromImage options.buttonHoverImage

    @normalBg = new PIXI.Sprite(options.buttonImage)
    @addChild(@normalBg)


    @w = @normalBg.width
    @h = @normalBg.height

    return if options?.tint?

    @downBg = new PIXI.Sprite(options.buttonHoverImage)
    @downBg.visible = false
    @addChild(@downBg)

    @hoverBg = new PIXI.Sprite(options.buttonHoverImage)
    @hoverBg.visible = false
    @addChild(@hoverBg)

  #----------------------------------------------

  addTextLabel: ->

    @textLabel = new PIXI.Text @text, @style

    position =
      x: Math.floor (@w - @textLabel.width)/2
      y: Math.floor((@h - @textLabel.height)/2)

    @textLabel.position = position
    @textLabel.resolution = __dpi
    @textLabel.updateText()

    @addChild @textLabel

  #----------------------------------------------

  addShadow: ->
    shadow = new PIXI.Graphics()
    shadow.beginFill(0x000000)
    shadow.drawRoundedRect(0,2,@w,@h,@cornerRadius+3)
    shadow.endFill()
    shadow.alpha = 0.3
    @addChild(shadow)

    blurFilter = new PIXI.filters.BlurFilter()
    blurFilter.blur = 1
    shadow.filters = [blurFilter]

    # dropShadowFilter = new PIXI.filters.DropShadowFilter()
    # dropShadowFilter.color = 0x000000
    # dropShadowFilter.alpha = 0.3
    # dropShadowFilter.blur = 6
    # dropShadowFilter.distance = 2
    # dropShadowFilter.angle = 0
    # shadow.filters = [dropShadowFilter]

  #----------------------------------------------

  updateText: (text) ->
    @textLabel.text = text
    @textLabel.position =
      x: Math.floor (@w - @textLabel.width)/2
      y: Math.floor (@h - @textLabel.height)/2

    @reset()

  #----------------------------------------------

  mousedown: (e) ->
    return unless @isEnabled

    e.stopPropagation()
    if @options?.tint?
      @normalBg.tint = @options.tint
      return
    @hoverBg.visible = false
    @normalBg.visible = false
    @downBg.visible = true

  #----------------------------------------------

  mouseover: (e) ->
    return unless @isEnabled
    # e.stopPropagation()

    @hovered() if @hovered?

    if @options?.tint?

      @normalBg.tint = @options.tint
      return
    @hoverBg.visible = true
    @normalBg.visible = false
    @downBg.visible = false

  #----------------------------------------------

  mouseout: (e) ->
    # e.stopPropagation()
    @reset()

  #----------------------------------------------

  mouseup: (e) ->
    return unless @isEnabled
    # e.stopPropagation()
    @reset()
    @_tapped e

  #----------------------------------------------

  mouseupoutside: (e) ->

    # e.stopPropagation()
    @reset()

  #----------------------------------------------

  touchstart: (e) ->
    return unless @isEnabled
    e.data.originalEvent.preventDefault()
    # e.stopPropagation()
    if @options?.tint?
      @normalBg.tint = @options.tint
      return
    @hoverBg.visible = true
    @normalBg.visible = false
    @downBg.visible = false

  #----------------------------------------------

  touchend: (e) ->
    e.data.originalEvent.preventDefault()
    # e.stopPropagation()
    @reset()
    @_tapped e

  #----------------------------------------------
  #
  touchendoutside: (e) ->
    # e.stopPropagation()
    @reset()

  #----------------------------------------------

  reset: ->
    if @options?.tint?
      @normalBg.tint = 0xFFFFFF if @normalBg?
      return
    @hoverBg.visible = false if @hoverBg?
    @normalBg.visible = true if @normalBg?
    @downBg.visible = false if @downBg?

  #----------------------------------------------

  enable: ->
    @reset()
    @interactive = true
    @buttonMode = true
    @alpha = 1
    @isEnabled = true

  #----------------------------------------------

  disable: ->
    @reset()
    @interactive = false
    @buttonMode = false
    @alpha = 0.5
    @isEnabled = false

  #----------------------------------------------

  _tapped: (e) ->

    if @tapped?
      @tapped(e)
      soundManager.click()
    else if @action?
      eventManager.trigger @action
      soundManager.click()
    else
      console.error 'Button has no Action'

    if @options.type is 'primary' and not @remainActive
      @disable()

  #----------------------------------------------

  setOn: ->
    @state = true
    @normalBg.texture = @options.buttonImage
    return if @options?.tint?
    @downBg.texture = @options.buttonHoverImage
    @hoverBg.texture = @options.buttonHoverImage

  #----------------------------------------------

  setOff: ->
    @state = false
    @normalBg.texture = @options.buttonOffImage
    return if @options?.tint?
    @downBg.texture = @options.buttonOffHoverImage
    @hoverBg.texture = @options.buttonOffHoverImage

  #----------------------------------------------

  toggleState: ->
    if @state
      @setOff()
    else
      @setOn()
    @state

  #----------------------------------------------


module.exports = BaseButton


// WEBPACK FOOTER //
// ./coffee/base/base-button.coffee